<app-module-header
  [title]="organization.organizationName + ' - ' + 'Parkifly ' + ('CUSTOMER.CUSTOMERS' | transloco)"
  icon="home"
></app-module-header>
